import axios from "axios";
import apiSettings from "../../../../utils/apiSettings";
import {
    SEARCH_POSTS, SEARCH_SET_FILTER, LOADING, FILTER_OPEN_MECHANIC
} from '../actionTypes';

export const searchPostsAction = (params, history, hash) => async (dispatch, getState) => {
    try {
        dispatch(loading());
        if (history) {
            history.push({
                pathname: apiSettings.slug,
                hash: `${hash}`,
            });
        }
        const result = await axios.post(apiSettings.baseApi, params);

        dispatch({
            type: SEARCH_POSTS,
            payload: result.data,
        });
    } catch (error) {
        console.log(error);
    }
};

export const loading = () => ({
    type: LOADING,
});

export const setFilter = (params, isRemove) => ({
    type: SEARCH_SET_FILTER,
    payload: params,
    isRemove,
});
